import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import PageTop, { MainPageTop } from '../components/pageTop/PageTop';
import SearchTab from '../components/searchTab/SearchTab';
import Banner from './components/Banner';
import FillterButton from './components/FilterButton';
import MainCalendar from './components/MainCalendar';
import ClickButton from './components/ClickButton';
import MainService from '../../service/main/main';
import BondSerivce from '../../service/Bond';
import ExchangeHiLight from './components/ExchangeHiLight';
import ItemAndSample from './components/ItemAndSample';
import Footer from '../components/footer/Footer';
import EasyFilter from '../search/filter/EasyFilter';
import Menu from '../components/menu/Menu';
import NoticeBox from './components/NoticeBox';
import ScrollToTopButton from '../components/ScrollToTopButton';
import QuantBox from './components/QuantBox';
import EventModal from './components/EventModal';
import AlgorithmSection from './components/AlgorithmSection';

const Main = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [currentTab, setCurrentTab] = useState('간편검색');
  const [imminentList, setImminentList] = useState(); // 매각임박물건
  const [sampleList, setSampleList] = useState(); // 샘플데이터
  const [exchangeStatus, setExChangeStatus] = useState(); // 교환소 상태
  const [ExchangeHiLightList, setExchangeHiLightList] = useState(); // 교환소 하이라이트
  const [exchangeList, setExchangeList] = useState(); // 교환소 리스트
  const [noticeList, setNoticeList] = useState([]); // 공지사항 리스트

  const navigate = useNavigate();

  const getMainData = async () => {
    try {
      const result = await MainService.main();
      setNoticeList(result.data.noticeList.list);
      setImminentList(result.data.imminentList);
      setSampleList(result.data.sampleList);
    } catch (error) {
      console.error('Error fetching main data:', error);
    }
  };

  const getModalData = () => {
    if (
      sessionStorage.getItem('event_modal') ===
      `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`
    ) {
      setOpenModal(false);
    } else {
      setOpenModal(true);
    }
  };

  useEffect(() => {
    getModalData();
    getMainData();
    getExchangeList();
    getExchangeStatus();
  }, []);

  const getExchangeStatus = async () => {
    try {
      const res = await BondSerivce.status();
      setExChangeStatus(res.data);
    } catch (error) {
      console.log('getStatus 함수에서 에러 발생:', error);
    }
  };

  const getExchangeList = async () => {
    try {
      const res = await BondSerivce.list('', '', '', '', '', 4, 0);
      setExchangeHiLightList(res.data);
    } catch (error) {
      console.log('getList 함수에서 에러 발생:', error);
    }
  };

  return (
    <Container>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          background: '#050037',
        }}
      >
        <img
          src="/assets/images/banner/long-banner.png"
          alt="Top Banner"
          style={{
            maxWidth: '100%',
            objectFit: 'contain',
            height: '40px',
          }}
          onClick={() => {
            navigate('/promotion/땅집고옥션-오픈기념-이벤트');
          }}
        />
      </div>
      <ScrollToTopButton />
      <MainPageTop setOpenMenu={setOpenMenu} menu={true} />
      <SearchTab
        page="main"
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
      />
      <EasyFilter page="main" />
      <NoticeBox noticeList={noticeList} />
      <Banner />
      <FillterButton />
      <ScrollContainer>
        <AlgorithmSection page="main" />
      </ScrollContainer>
      <Divider />
      <QuantBox />
      <Divider />
      <MainCalendar />
      <Divider />
      {/* <ClickButton /> */}
      {/* <ExchangeHiLight
        exchangeStatus={exchangeStatus}
        ExchangeHiLightList={ExchangeHiLightList}
      /> */}
      {sampleList && imminentList && (
        <ItemAndSample
          imminentList={imminentList}
          sampleList={sampleList}
        ></ItemAndSample>
      )}
      <Footer />
      {openMenu && <Menu page="main" setOpenMenu={setOpenMenu} />}
      {openModal && <EventModal setOpenModal={setOpenModal} />}
    </Container>
  );
};

export default Main;

const Divider = styled.div`
  width: 100%;
  height: 8px;
  background-color: rgba(112, 115, 124, 0.05);
`;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  overflow: hidden;
  position: relative;
`;

const ScrollContainer = styled.div`
  padding: 16px 16px 32px;
  display: flex;
  flex-direction: row;
  gap: 24px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
